"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoChatCubby = exports.VideoChatCubbyWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _ = require("./..");
var _utils = require("../../utils");
var _utils2 = require("./utils");
var _excluded = ["children", "patient"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var VideoChatCubbyContext = /*#__PURE__*/_react.default.createContext({});
var useVideoChatCubby = function useVideoChatCubby() {
  return (0, _react.useContext)(VideoChatCubbyContext);
};
exports.useVideoChatCubby = useVideoChatCubby;
var VideoChatCubbyContextProvider = function VideoChatCubbyContextProvider(_ref) {
  var children = _ref.children,
    booking = _ref.booking,
    patient = _ref.patient,
    initialScreen = _ref.initialScreen;
  // useVideoChat values are undefined in admin app b/c VideoChatContext is not rendered
  var _useVideoChat = (0, _.useVideoChat)(),
    _useVideoChat$target = _useVideoChat.target,
    target = _useVideoChat$target === void 0 ? {} : _useVideoChat$target,
    setTarget = _useVideoChat.setTarget,
    isVideoActive = _useVideoChat.isVideoActive;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useClosestBooking = (0, _utils2.useClosestBooking)(),
    closestBooking = _useClosestBooking.closestBooking,
    getClosestBooking = _useClosestBooking.getClosestBooking;
  var targetBooking = booking || target.booking || closestBooking;
  var targetPatient = patient || target;
  var cubbyProps = (0, _utils2.useCubby)({
    patient: targetPatient,
    booking: targetBooking,
    initialScreen: initialScreen
  });
  var _useRequest = (0, _utils.useRequest)((0, _utils.getPatientBookingsUrl)(targetPatient === null || targetPatient === void 0 ? void 0 : targetPatient.id), {
      ready: !!(targetPatient !== null && targetPatient !== void 0 && targetPatient.id),
      refreshDeps: [targetPatient === null || targetPatient === void 0 ? void 0 : targetPatient.id]
    }),
    bookings = _useRequest.data,
    refreshBookings = _useRequest.refresh,
    loadingBookings = _useRequest.loading;
  var upcomingBookings = (0, _utils.getClinicianFutureBookings)({
    id: user === null || user === void 0 ? void 0 : user.accountId
  }, bookings || []);
  (0, _react.useEffect)(function () {
    // When target is set, check if it does not contain a specific booking
    // If it doesn't, get closest booking from backend
    // since all video session notes must be associated with a booking
    if (targetPatient !== null && targetPatient !== void 0 && targetPatient.id && (0, _lodash.isEmpty)(targetBooking)) {
      getClosestBooking(targetPatient.id);
    }

    // If booking is being approximated via useClosestBooking, update the video
    // call target w/ said booking
    if (isVideoActive && !target.booking && closestBooking && (targetBooking === null || targetBooking === void 0 ? void 0 : targetBooking.id) === (closestBooking === null || closestBooking === void 0 ? void 0 : closestBooking.id)) {
      setTarget(function (prevTarget) {
        return _objectSpread(_objectSpread({}, prevTarget), {}, {
          booking: _objectSpread({}, closestBooking)
        });
      });
    }
  }, [targetPatient, targetBooking, closestBooking]);
  return /*#__PURE__*/_react.default.createElement(VideoChatCubbyContext.Provider, {
    value: _objectSpread(_objectSpread({}, cubbyProps), {}, {
      patient: targetPatient,
      booking: targetBooking,
      showNewApptNotice: !loadingBookings && !upcomingBookings.length,
      onScheduleAppointmentSuccess: refreshBookings
    })
  }, children);
};
var VideoChatCubbyWrapper = function VideoChatCubbyWrapper(_ref2) {
  var children = _ref2.children,
    patient = _ref2.patient,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useVideoChat2 = (0, _.useVideoChat)(),
    target = _useVideoChat2.target;
  var targetPatient = patient || target;
  return (
    /*#__PURE__*/
    // Use key to reset state when call starts/ends
    // Use target.id as key - key will toggle between patient ID
    // and `undefined` when call ends and target is cleared
    _react.default.createElement(VideoChatCubbyContextProvider, _extends({
      key: JSON.stringify(targetPatient === null || targetPatient === void 0 ? void 0 : targetPatient.id),
      patient: patient
    }, props), children)
  );
};
exports.VideoChatCubbyWrapper = VideoChatCubbyWrapper;